import { customElement, property, query, state } from 'lit/decorators.js'
import { CSSResultGroup, html, LitElement, nothing } from 'lit'

import { defaultProduct, ImageHotspotProduct } from 'components/discovery/widgets/image-hotspot/typing/product-types.js'

import { IMAGE_HOTSPOT_STORE, ImageHotspotStore } from 'components/discovery/widgets/image-hotspot/image-hotspot-store.js'

import { CSESlideIn } from '@cloudsuite/mosaic-elements'
import { inject } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { createEffect } from '@cloudsuite/mosaic-shared/scripts/signals.js'


@customElement('csc-image-hotspot-slide-in')
export class CSCImageHotspotSlideIn extends LitElement {
  static override styles: CSSResultGroup = [hostStyle]

  @query('cse-slide-in')
  slideIn!: CSESlideIn

  @inject(IMAGE_HOTSPOT_STORE)
  imageHotspotStore!: ImageHotspotStore

  @state()
  product: ImageHotspotProduct = defaultProduct

  open() {
    this.slideIn.open()
  }

  @property({ type: Boolean, attribute: 'display-rating' })
  displayRating: boolean = false

  @property({ type: Boolean, attribute: 'display-stock' })
  displayStock: boolean = false

  @property({ type: Boolean, attribute: 'display-prices' })
  displayPrices: boolean = false

  @property({ type: String, attribute: 'locale' })
  locale: string = 'en-US'

  constructor() {
    super()

    createEffect(() => {
      this.product = this.imageHotspotStore.product()
    })
  }

  override render() {
    return html`
      <cse-slide-in class="csc-image-hotspot-slide-in">
        <csc-product-image
          source="${this.product.image}"
          alt="${this.product.name}"
        ></csc-product-image>
        <cse-group direction="column" row-gap="06">
          <cse-group direction="column">
            <cse-text variant="product-title-m">
              ${this.product.name}
            </cse-text>
            ${this.displayRating ? html`
              <csc-product-rating 
                value="${this.product.rating}" 
                count="${this.product.ratingCount}"
              ></csc-product-rating>
            ` : nothing}
          </cse-group>
          <cse-text class="description">
            ${this.product.description}
          </cse-text>
            
          ${this.displayStock ? html`
            <csc-stock-indication
              stock="${this.product.stock}"
              stock-text="${this.product.stockMessage}"
            ></csc-stock-indication>
          ` : nothing}
        </cse-group>
          
        ${this.displayPrices ? html`
          <csc-price
            sale-price="${this.product.priceSale}"
            customer-price="${this.product.priceCustomer}"
            consumer-price="${this.product.priceConsumer}"
            currency-code="${this.product.priceCurrency}"
            locale="${this.locale}"
          ></csc-price>
        ` : nothing}
                    
        <cse-link url="${this.product.url}">View product</cse-link>
      </cse-slide-in>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-image-hotspot-slide-in': CSCImageHotspotSlideIn,
  }
}
